import { CompositeDecorator } from "draft-js";
import EmailPlaceholderSpan from "./EmailPlaceholderSpan";

// ///////////////////////////////////////
// Email decorator
// Function to find placeholder matches inside text via regex
function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr, start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}

// Decorator for highlighting "Patient Name" and "Office Name"
export const placeholderDecorator = new CompositeDecorator([
  {
    strategy: (contentBlock, callback) => {
      const placeholder_regex = /\bPatient Name\b|\bOffice Name\b/g;
      findWithRegex(placeholder_regex, contentBlock, callback);
    },
    component: EmailPlaceholderSpan,
  },
]);

// ///////////////////////////////////////
// Patient filter based on name, email or phone
// export function patientInputFilterQuery(searchPatientInput) {
//   const nameRegex = /^[a-zA-Z\s'\-]+$/;
//   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   const phoneRegex = /^[2-9]\d{2}-\d{3}-\d{4}$/;
//   const queryParams = new URLSearchParams();

//   console.log(searchPatientInput);
//   // Check email first (more specific)
//   if (emailRegex.test(searchPatientInput)) {
//     queryParams.set("email", searchPatientInput);
//   }

//   // Check name
//   else if (nameRegex.test(searchPatientInput)) {
//     queryParams.set("name", searchPatientInput);
//   }
//   // Check phone number
//   else if (phoneRegex.test(searchPatientInput)) {
//     queryParams.set("phone", searchPatientInput);
//   }

//   return queryParams;
// }

export function patientInputFilterQuery(searchPatientInput, boardType) {
  const queryParams = new URLSearchParams();
  const trimmedInput = searchPatientInput.trim();

  // Email check (contains @ and .)
  if (trimmedInput.includes('@') || trimmedInput.includes('.')) {
    queryParams.set("email", trimmedInput);
  } // Phone check - if it's all numbers or has typical phone separators
  else if (/[\d\-\(\)\.]/.test(trimmedInput) && trimmedInput.replace(/\D/g, "").length >= 3) {
    if (boardType === "manual") queryParams.set("phone", trimmedInput);
    else queryParams.set("phone_number", trimmedInput);
  } // Otherwise assume it's a name
  else {
    queryParams.set("name", trimmedInput);
  }

  return queryParams;
}

export const getScheduleTag = (actionTrigger) => {
  switch (actionTrigger.trigger_type) {
    case "manual trigger":
      return `Manual - ${actionTrigger.trigger_time.split('T')[0].replace(/-/g, '/')}`;
  
    case "recurring":
      return `Recurring - ${actionTrigger.recurring_period.replace(/_/g, ' ')}`;

    case "event":
      return `Event - ${actionTrigger.trigger_event.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}`;

    case "action completion":
      return `Action Completion - ${actionTrigger.related_actions.length} ${actionTrigger.related_actions.length > 1 ? "Actions" : "Action"}`;      
  }
}

export function generateSimpleId() {
  return 'name-' + Date.now() + '-' + Math.random().toString(36).slice(2, 11);
}

export const handleFilterTag = (tag) => {
  // Case 1: Contains ":" and starts with first_name, last_name, or gender
  if (tag.includes(':')) {
    const colonIndex = tag.indexOf(':');
    const beforeColon = tag.substring(0, colonIndex).trim();
    const afterColon = tag.substring(colonIndex + 1).trim();
    
    if (['first_name', 'last_name', 'gender'].includes(beforeColon)) {
      return {filter: afterColon};
    }
    
    // Case 2: Contains ":" but not first_name, last_name, or gender
    return { filter: beforeColon.replace(/_/g, ' '), info: afterColon.replace(/_/g, ' ') };
  }
  
  // Case 3: All other cases - replace underscores with spaces
  return {filter: tag.replace(/_/g, ' ')};
}